var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioButtonGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 63,
    viewBox: "0 0 81 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 15.5,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#80959B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 27.5,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#E6EAEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 39.5,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#E6EAEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonGroup);
export default __webpack_public_path__ + "static/media/RadioButtonGroup.5041f1dd1b713614588e4726fe89005a.svg";
export { ForwardRef as ReactComponent };